/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import React from "react";
import WhyAskingPopup from "../../../shared-ui/popup/why-asking-popup";
import WhyAskingComponent from "../../../shared-ui/why-asking";
import DropdownWithCheckbox from "../../../shared-ui/dropdownWithCheckbox";
//import { getUpdatedOptionsList } from "../../../../utils/optionsList";
import CheckBox from "../../../shared-ui/checkbox";
import _ from "lodash";
import { setUserResponse } from "../../../../utils/userResponse"; // set path accordingly

// Interface Search And Select Component Props
interface SearchAndSelectComponentProps {
  questionTitle: string;
  questionSubTitle?: string;
  inputType?: string;
  inputPlaceHolder: string;
  errorMsg: any;
  whyQuestionList: [];
  listOfAnswers: any;
  handleChildContinue?: any;
  handleSuccessfulContinue: any;
  dropDownTitle: string;
  recoId: any;
  contentTypeId: any;
  t?: any;
  dependent?: any;
  cmDependent?: any;
  restrictionOptions?: any;
  nonListCheckboxClick?: any;
  checkboxOption?: any;
}

// Interface Search And Select Component state
interface SearchAndSelectComponentState {
  inputValue: any;
  isEmptyValue: boolean;
  isPopupOpen: boolean;
  isInputVisible: boolean;
  selectedIndex: number;
  optionsList: any;
  isNoneChecked: any;
  isDisableNone: boolean;
  isDisableOptions: boolean;
  isError: boolean;
  updatedOptionsList?: any;
  questionTitleState: string;
}

/**
 * Used for any answer type is in a Search and select.
 *
 * @namespace  SearchAndSelectComponent
 */

class SearchAndSelectComponent extends React.Component<
  SearchAndSelectComponentProps,
  SearchAndSelectComponentState
> {
  myRef: any;
  constructor(props: SearchAndSelectComponentProps) {
    super(props);
    this.myRef = React.createRef();
    this.state = {
      inputValue: "",
      isEmptyValue: false,
      isPopupOpen: false,
      isInputVisible: false,
      selectedIndex: 0,
      optionsList: [],
      isNoneChecked: false,
      isDisableNone: false,
      isDisableOptions: false,
      isError: false,
      questionTitleState: "",
    };
  }

  componentDidMount = () => {
    this.props.handleChildContinue(this.handleError);
    // const data: any = getUpdatedOptionsList(this.props.listOfAnswers);
    // data.forEach(function (item: { isChecked: boolean }) {
    //   item.isChecked = false;
    // });
    // this.setState({ optionsList: data });
    this.setState({
      questionTitleState: this.props.questionTitle,
    });
    const { restrictionOptions } = this.props;

    if (restrictionOptions) {
      fetch(restrictionOptions.url)
        .then((response) => response && response.json())
        .then((output) => {
          const data: any = output;
          data.forEach(function (item: { isChecked: boolean }) {
            item.isChecked = false;
          });
          this.setState({ updatedOptionsList: data });
        })
        .catch((err) => console.log("error is", err));
    }
  };

  // componentDidUpdate = () => {
  //   const { listOfAnswers } = this.props;
  //   const { optionsList } = this.state;
  //   const data: any = getUpdatedOptionsList(listOfAnswers);
  //   data.forEach(function (item: { isChecked: boolean }) {
  //     item.isChecked = false;
  //   });
  //   let listOfAnswersProps = data.map(function (element: any) {
  //     return element.value;
  //   });
  //   let listOfAnswersState = optionsList.map(function (element: any) {
  //     return element.value;
  //   });
  //   const equal = _.isEqual(listOfAnswersProps, listOfAnswersState);

  //     this.setState({
  //       // optionsList: data,
  //       isError: false,
  //       isDisableNone: false,
  //       isDisableOptions: false,
  //       isNoneChecked: false,
  //     });
  //   }
  // };

  componentDidUpdate = () => {
    // this.myRef.current.scrollTo(0, 0);
    const { restrictionOptions } = this.props;
    if (this.props.questionTitle !== this.state.questionTitleState) {
      this.setState({
        questionTitleState: this.props.questionTitle,
        isError: false,
        isDisableNone: false,
        isDisableOptions: false,
        isNoneChecked: false,
      });

      if (restrictionOptions) {
        fetch(restrictionOptions.url)
          .then((response) => response && response.json())
          .then((out) => {
            const data: any = out;
            data.forEach(function (item: { isChecked: boolean }) {
              item.isChecked = false;
            });
            this.setState({ updatedOptionsList: data });
          })
          .catch((err) => console.log("error is", err));
      }
    }
  };

  /**
   * This method is used for handling error
   *
   */

  handleError = () => {
    const { /*optionsList,*/ isNoneChecked } = this.state;
    const { updatedOptionsList } = this.state;
    // const filteredOptions = optionsList.filter(
    //   (obj: any) => obj.isChecked === false
    // ).length;

    const filteredOptions = updatedOptionsList?.filter(
      (obj: any) => obj.isChecked === false
    ).length;

    if (
      filteredOptions === /*optionsList.length*/ updatedOptionsList?.length &&
      !isNoneChecked
    ) {
      this.setState({
        isError: true,
      });
    } else {
      this.setState(
        {
          isError: false,
        },
        () => {
          if (this.props.dependent || this.props.cmDependent) {
            // TODO:I Like everything
            const data: any = this.getSelectedData();
            if (this.props.dependent && this.props.cmDependent) {
              const { conditions, dependent_content_type_id } =
                this.props.dependent;
              const selectedValues = data?.recoValues;
              let newArray = _.intersection(conditions, selectedValues);
              let isValueFound: boolean = newArray?.length > 0 ? true : false;
              /*if strict checking of values is required
              let isValueFound = _.isEqual(conditions, selectedValue);
              */
              const addRemoveData = this.handleAddRemoveCm();
              if (isValueFound) {
                addRemoveData.valuesToRemove = _.union(
                  dependent_content_type_id,
                  addRemoveData.valuesToRemove
                );
              } else {
                addRemoveData.valuesToAdd = _.union(
                  dependent_content_type_id,
                  addRemoveData.valuesToAdd
                );
              }

              this.props.handleSuccessfulContinue(
                false,
                false,
                false,
                false,
                true,
                addRemoveData.valuesToAdd,
                addRemoveData.valuesToRemove
              );
            } else {
              if (this.props.dependent) {
                const { conditions, dependent_content_type_id } =
                  this.props.dependent;
                const selectedValues = data?.recoValues;
                let newArray = _.intersection(conditions, selectedValues);
                let isValueFound: boolean = newArray?.length > 0 ? true : false;
                /*if strict checking of values is required
                let isValueFound = _.isEqual(conditions, selectedValue);
                */
                this.props.handleSuccessfulContinue(
                  false,
                  false,
                  dependent_content_type_id,
                  isValueFound,
                  false,
                  false,
                  false
                );
              }

              if (this.props.cmDependent) {
                const addRemoveData = this.handleAddRemoveCm();
                this.props.handleSuccessfulContinue(
                  false,
                  false,
                  false,
                  false,
                  true,
                  addRemoveData.valuesToAdd,
                  addRemoveData.valuesToRemove
                );
              }
            }
          } else {
            this.getSelectedData();
            this.props.handleSuccessfulContinue();
          }
        }
      );
    }
  };

  /**
   *
   * handleAddRemoveCm -- data to remove or add
   */
  handleAddRemoveCm = () => {
    const cmDepList: any = this.props.cmDependent;
    const data: any = this.getSelectedData();
    const selectedValue = data?.recoValues;
    let valuesToAdd: any = [];
    let valuesToRemove: any = [];
    _.map(cmDepList, (eachData: any) => {
      if (!_.isEmpty(eachData)) {
        let newArray = _.intersection(eachData.conditions, selectedValue);
        let isCmValueFound: boolean = newArray.length > 0 ? true : false;
        if (isCmValueFound) {
          valuesToRemove.push(...eachData.dependent_content_type_id);
        } else {
          valuesToAdd.push(...eachData.dependent_content_type_id);
        }
      }
    });
    let cmData: any = {
      valuesToAdd: valuesToAdd,
      valuesToRemove: valuesToRemove,
    };
    return cmData;
  };

  /**
   * @Name - getSelectedData
   * @Desc - This is used to find user response from options list
   *          and send to store.
   */
  getSelectedData = () => {
    let responseData: Object = {};
    let recoValue: Array<String> = [];
    let values: Array<String> = [];
    if (!this.state.isNoneChecked) {
      _.map(
        /*this.state.optionsList*/ this.state.updatedOptionsList,
        (data: any) => {
          if (data?.isChecked) {
            recoValue.push(data.id);
            values.push(data.name);
            responseData = {
              contentTypeId: this.props.contentTypeId,
              recoId: this.props.recoId,
              recoValues: recoValue,
              values: values,
            };
          }
        }
      );
    } else {
      responseData = {
        contentTypeId: this.props.contentTypeId,
        recoId: this.props.recoId,
        recoValues: [], // TODO:I Like everything
        values: [],
      };
    }
    setUserResponse(responseData);
    return responseData;
  };
  /**
   * This method is used for handle input change
   * @param {Object} evt
   *
   */
  handleInputChange = (evt: any) => {
    this.setState({
      inputValue: evt.target.value,
    });
  };

  /**
   * This method is used for handleAsking Popup open
   *
   */
  handlePopup = () => {
    this.setState({
      isPopupOpen: true,
    });
  };

  /**
   * This method is used for handle Why Asking Popup close
   *
   */
  closePopup = () => {
    this.setState({
      isPopupOpen: false,
    });
  };

  /**
   * This method is used to handle checkbox click
   * @param {boolean} isChecked
   * @param {string} value
   */
  handleCheckboxClick = (isChecked: boolean, value: string) => {
    // const { optionsList } = this.state;
    // const data: any = optionsList;
    // const objIndex = data.findIndex((obj: any) => obj.value === value);
    // data[objIndex].isChecked = isChecked;
    // this.setState({ optionsList: data });
    // const filteredOptions = this.state.optionsList.filter(
    //   (obj: any) => obj.isChecked === true
    // ).length;
    const { updatedOptionsList } = this.state;
    const data: any = updatedOptionsList;
    const objIndex = data.findIndex((obj: any) => obj.name === value);
    data[objIndex].isChecked = isChecked;
    this.setState({ updatedOptionsList: data });

    const filteredOptions = this.state.updatedOptionsList.filter(
      (obj: any) => obj.isChecked === true
    ).length;
    if (filteredOptions > 0) {
      this.setState({
        isDisableNone: true,
        isError: false,
      });
    } else {
      this.setState({
        isDisableNone: false,
      });
    }
  };

  /**
   * This method is used to remove tag from tags list
   * @param {string} value
   *
   */
  handleRemoveTag(value: string) {
    //const data: any = this.state.optionsList;
    const data: any = this.state.updatedOptionsList;
    data.forEach((element: any) => {
      if (element.name === value) {
        element.isChecked = false;
      }
    });
    // this.setState({ optionsList: data });
    this.setState({ updatedOptionsList: data });
    // const filteredOptions = this.state.optionsList.filter(
    //   (obj: any) => obj.isChecked === true
    // ).length;

    const filteredOptions = this.state.updatedOptionsList.filter(
      (obj: any) => obj.isChecked === true
    ).length;

    if (filteredOptions > 0) {
      this.setState({
        isDisableNone: true,
        isError: false,
      });
    } else {
      this.setState({
        isDisableNone: false,
      });
    }
  }

  /**
   * This method is used to handle none checkbox click
   * @param {any} evt
   *
   */
  handleCheckbox = (evt: any) => {
    const isChecked = evt.target.checked;
    this.setState({ isNoneChecked: isChecked });

    // const data = this.state.optionsList;
    const data = this.state.updatedOptionsList;
    if (isChecked) {
      data?.forEach((element: any) => {
        element.isChecked = false;
      });
      this.setState({
        isDisableOptions: true,
        isError: false,
        //optionsList: data,
        updatedOptionsList: data,
      });
    } else {
      this.setState({
        isDisableOptions: false,
      });
    }
  };
  handleNonListCheckBox = (evt: any) => {
    const isChecked = evt.target.checked;
    this.setState({ isNoneChecked: isChecked });
    if (isChecked) {
      this.setState({ isDisableNone: false, isDisableOptions: true });
    } else {
      this.setState({ isDisableNone: true, isDisableOptions: false });
    }
  };

  render() {
    const {
      questionTitle,
      questionSubTitle,
      errorMsg,
      whyQuestionList,
      inputPlaceHolder,
      dropDownTitle,
      checkboxOption,
    } = this.props;
    const {
      optionsList,
      isNoneChecked,
      isDisableNone,
      isDisableOptions,
      isError,
      updatedOptionsList,
    } = this.state;

    // const selectedTagList =
    //   optionsList && optionsList.filter((obj: any) => obj.isChecked === true);
    const selectedTagList =
      updatedOptionsList &&
      updatedOptionsList.filter((obj: any) => obj.isChecked === true);

    return (
      <div className="inner-wrapper search-select-container">
        <WhyAskingPopup
          {...this.props}
          open={this.state.isPopupOpen}
          close={this.closePopup}
          list={whyQuestionList}
        />

        <div className="question-wrappper">
          <div className="question-label">{questionTitle || ""}</div>
          <div className="question-sub-label">{questionSubTitle || ""}</div>
        </div>

        {/* Search and select inner wrapper Start */}
        <div className="search-select-wrapper">
          <div className="dropdown-conatiner">
            <div className="dropdown-wrapper">
              <DropdownWithCheckbox
                inputType="text"
                inputValue={(evt: any) => this.handleInputChange(evt)}
                isDisabled={isDisableOptions}
                isError={isError}
                //list={optionsList}
                list={this.state.updatedOptionsList}
                dropdown_title={dropDownTitle}
                dropdown_placeHolder={inputPlaceHolder}
                handleCheckboxClick={(isChecked: boolean, value: string) =>
                  this.handleCheckboxClick(isChecked, value)
                }
                contentTypeId={this.props.contentTypeId}
                recoId={this.props.recoId}
                // nonListCheckboxClick={(evt: any) => this.handleCheckbox(evt)}
                nonListCheckboxClick={(evt: any) =>
                  this.handleNonListCheckBox(evt)
                }
              />
            </div>
          </div>

          {/* Tags container start */}
          {selectedTagList && selectedTagList.length > 0 ? (
            <div className={"tags-container"}>
              <div className="tags-wrapper">
                <div className="tags-list">
                  {selectedTagList.map((item: any) => (
                    <div className="tags">
                      <span className="label">{item && item.name}</span>
                      <span
                        tabIndex={0}
                        role="button"
                        aria-label="cross button for dis-select"
                        className="icon cross-icon"
                        onClick={() => this.handleRemoveTag(item && item.name)}
                        onKeyPress={(e: any) => {
                          if (e.key === "Enter" || e.key === " ") {
                            this.handleRemoveTag(item && item.name);
                          }
                        }}
                      ></span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ) : null}

          {/* Tags container Ends */}

          <div
            className={
              isDisableNone ? "checkbox-wrapper disable" : "checkbox-wrapper"
            }
          >
            <CheckBox
              className={isError ? "checkbox checkbox-error" : "checkbox"}
              onCheckboxClick={(evt) => this.handleCheckbox(evt)}
              isChecked={isNoneChecked}
            />
            <div className={isNoneChecked ? "list-label active" : "list-label"}>
              {checkboxOption}
            </div>
          </div>
          <div className={isError ? "error-msg" : "hide"}>
            {errorMsg && errorMsg.empty_error}
          </div>
        </div>

        {/* Search and select inner wrapper Ends */}

        {whyQuestionList && whyQuestionList.length > 0 ? (
          <WhyAskingComponent {...this.props} handlePopup={this.handlePopup} />
        ) : null}
      </div>
    );
  }
}

export default SearchAndSelectComponent;
